/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../../../components/company/Layout';
import { Box, HStack, VStack } from '@mybridge/ui/layout';
import IntroSection from 'v4/snippets/company/jobs/create/sections/Info';
import BenefitsSection from 'v4/snippets/company/jobs/create/sections/Benefits';
import ApplySection from 'v4/snippets/company/jobs/create/sections/Apply';
import RoleSection from 'v4/snippets/company/jobs/create/sections/Role';
import { useForm } from 'react-hook-form';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import {
  CreateJobsContext,
  CreateJobsProvider,
} from 'v4/components/company/Layout/context';
import { Card } from '@mybridge/ui';

const CreateCompanyJob = () => {
  // const { editDetails } = useSelector((state) => state.jobsReducer);
  const {
    isEdit,
    setSection,
    section,
    jobDetails,
    setJobDetails,
    screeningQuestions,
    setScreeningQuestions,
    setIsEdit,
  } = useContext(CreateJobsContext);

  // useEffect(() => {
  //   if (editDetails?.id) {
  //     setJobDetails(editDetails);
  //     setScreeningQuestions(editDetails?.screening_question);
  //     setIsEdit(true);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // console.log(editDetails);

  return (
    <AuthenticatedProviders>
      <Layout>
        
          <>
            {section === 1 && (
              <IntroSection
                setSection={setSection}
                jobDetails={jobDetails}
                setJobDetails={setJobDetails}
                isEdit={isEdit}
              />
            )}
            {section === 2 && (
              <BenefitsSection
                setSection={setSection}
                jobDetails={jobDetails}
                setJobDetails={setJobDetails}
                isEdit={isEdit}
              />
            )}
            {section === 3 && (
              <ApplySection
                setSection={setSection}
                jobDetails={jobDetails}
                setJobDetails={setJobDetails}
                isEdit={isEdit}
              />
            )}
            {section === 4 && (
              <RoleSection
                setSection={setSection}
                jobDetails={jobDetails}
                setJobDetails={setJobDetails}
                isEdit={isEdit}
              />
            )}
          </>
      </Layout>
    </AuthenticatedProviders>
  );
};

export default CreateCompanyJob;
